var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.143,
    height: 13.41,
    viewBox: "0 0 11.143 13.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M16.638,59.06a.614.614,0,0,0-.609-.559H14.521v-.6a2.652,2.652,0,0,0-5.3,0v.6H7.709a.615.615,0,0,0-.611.559l-.8,8.93a.612.612,0,0,0,.159.47.6.6,0,0,0,.45.2h9.925a.629.629,0,0,0,.607-.7Zm-7.421.666v.7a.611.611,0,0,0,1.223,0v-.7H13.3v.7a.611.611,0,0,0,1.223,0v-.7h.949l.689,7.709H7.577l.691-7.709ZM13.3,58.5H10.44v-.6a1.429,1.429,0,0,1,2.858,0Z",
    transform: "translate(-6.295 -55.247)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopingIcon);
export default __webpack_public_path__ + "static/media/shoping-icon.0ea45961362a3ad1609287d96c0d8243.svg";
export { ForwardRef as ReactComponent };